module.exports = __webpack_public_path__ + "static/media/029_concepts_nk_2-06.a9dfdfb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/kp/029_concepts_nk_2-06.png
// module id = 527
// module chunks = 0